<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('tel1')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('tel10')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchleft">
                        <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                            <el-form-item :label="$t('tel6')" >
                                <el-input v-model="searchform.blurry" @click="$router.push('/user')" size="small" style="width:150px;"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('type')">
                                <el-input v-model="searchform.name"  @click="$router.push('/user')" size="small" style="width:80px;"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('tel85')">
                                <el-select v-model="searchform.idDial" style="width:120px;">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option :label="$t('tel11')" :value="0"></el-option>
                                    <el-option :label="$t('tel12')" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('status')">
                                <el-select v-model="searchform.type" style="width:120px;">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option :label="$t('tel62')" :value="0"></el-option>
                                    <el-option :label="$t('tel63')" :value="1"></el-option>
                                    <el-option :label="$t('tel64')" :value="2"></el-option>
                                    <el-option :label="$t('tel65')" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('tel66')">
                                <el-select size="small" v-model="searchform.principalId" filterable :placeholder="$t('qxz')" style="width:130px;">
                                    <el-option :label="$t('qxz')" :value="null"></el-option>
                                    <el-option v-for="item in principallist"
                                        :key="item.id"
                                        :label="item.nickName"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-select>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="searchright">
                        <el-button size="small" type="primary" @click="importFile">{{$t('tel13')}}</el-button>
                        <el-button size="small" type="primary" @click="downloadFile">{{$t('tel14')}}</el-button>
                        <el-button size="small" type="primary" @click="distributor(1)">{{$t('fp')}}</el-button>
                        <el-button size="small" type="primary" @click="distributor(2)">{{$t('tel86')}}</el-button>
                        <el-button size="small" type="primary" @click="distributor(3)">{{$t('tel94')}}</el-button>
                    </div>

                    <div class="top"></div>
                    <el-table :data="list" @selection-change="handleSelectionChange"
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="phone" :label="$t('phone')">
                            <!-- <template slot-scope="scope">
                                <el-link type="primary" @click="dial(scope.row.phone)">
                                    {{scope.row.phone}}
                                </el-link>
                            </template> -->
                        </el-table-column>
                        <el-table-column prop="level" :label="$t('re15')" width="180px">
                            <template slot-scope="scope">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="userName" :label="$t('userName')"></el-table-column>
                        <el-table-column prop="email" :label="$t('p8')"></el-table-column>
                        <el-table-column prop="recipient" :label="$t('tel60')"></el-table-column>
                        <el-table-column prop="name" :label="$t('tel61')"></el-table-column>
                        <el-table-column prop="isDial" :label="$t('tel15')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.isDial==0" type="primary" size="mini">{{$t('tel11')}}</el-tag>
                                <el-tag v-if="scope.row.isDial==1" type="info" size="mini">{{$t('tel12')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" :label="$t('status')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.type==0" type="primary" size="mini">{{$t('tel62')}}</el-tag>
                                <el-tag v-if="scope.row.type==1" type="info" size="mini">{{$t('tel63')}}</el-tag>
                                <el-tag v-if="scope.row.type==2" type="success" size="mini">{{$t('tel64')}}</el-tag>
                                <el-tag v-if="scope.row.type==3" type="info" size="mini">{{$t('tel65')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="150">
                            <template slot-scope="scope">
                                <el-tooltip style="margin-left:5px;" class="item" effect="dark" :content="$t('tel5')" placement="top">
                                    <el-button size="small" @click="openuser(scope.row)" type="primary" icon="el-icon-menu" circle plain></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <!-- <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page> -->
                            <el-pagination
                                @size-change="handchange"
                                @current-change="currentchange"
                                :current-page.sync="currentPage2"
                                :page-sizes="[10, 20, 50, 100, 200, 400]"
                                :page-size = "pageSize"
                                layout="sizes, prev, pager, next"
                                :total="total">
                            </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <pop-up :title="$t('tel16')" :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small">
                    <el-form-item :label="$t('p12')" prop="channel">
                        <el-radio-group v-model="form.channel">
                            <el-radio valeu="1" label="WhatsApp"></el-radio>
                            <el-radio valeu="2" label="Telephone"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>

        <pop-up :title="$t('tel17')" :isshow="showadd1" :haveconfirm="true" @close="getclose1" @confirm="getconfirm1">
            <div slot="box">
                <el-upload
                    ref="upload"
                    class="upload-demo"
                    drag
                    :auto-upload="false"
                    action="https://admin.aktivakus.com/data/api/tel/payroll"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">{{$t('tel18')}}<em>{{$t('tel19')}}</em></div>
                    <div class="el-upload__tip" slot="tip">{{$t('tel20')}}</div>
                </el-upload>
            </div>
        </pop-up>


        <pop-up :title="status == 1 ? $t('fp') : status == 2 ? $t('tel86') : $t('tel94')" :isshow="showaddfp" :haveconfirm="true" @close="getclosefp" @confirm="getconfirmfp">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form1" :rules="rules" size="small" label-width="300px">
                    <el-form-item v-if="status == 2" :label="$t('tel7')" prop="value1">
                        <el-date-picker
                            v-model="form1.value1"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item v-if="status != 3" :label="$t('tel66')" prop="principalId">
                        <el-select size="small" v-model="form1.principalId" filterable :placeholder="$t('qxz')">
                            <el-option :label="$t('qxz')" :value="null"></el-option>
                            <el-option v-for="item in principallist"
                                :key="item.id"
                                :label="item.nickName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item v-if="status == 3" label="渠道" prop="value1">
                        <el-radio-group v-model="form1.channel">
                            <el-radio valeu="1" label="1">原生</el-radio>
                            <el-radio valeu="2" label="2">流转</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item v-if="status == 3" :label="$t('type')" prop="value1">
                        <el-input v-model="form1.type"  size="small"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    userName: null,
                    email: null,
                    channel: null,
                },
                form1: {
                    id: null,
                    selectData: this.selectData,
                    principalId:null,
                    value1:'',
                    type:null,
                    channel:null,
                },
                searchform: {
                    blurry: "",
                    idDial: "",
                    type: "",
                    principalId: "",
                    name: "",
                },
                total: 1,
                pageNo: 1,
                pageSize: 10,
                loading: false,
                showadd: false,
                showadd1:false,
                showadddl:false,
                phone:null,
                selectData:null,
                list: [],
                status:null,
                principallist:[],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getprincipal()
            this.getList()
        },
        methods: {
            distributor(row) {
                this.showaddfp = true
                this.status = row
                this.form1 = {
                    id: null,
                    selectData: this.selectData,
                    principalId:null,
                    type:null,
                    channel:null,
                }
            },
            getprincipal() {
                _api.get(apiurl.users, {
                    roleId: 5,
                }).then(res => {
                    this.principallist = res.content
                })
            },
            openuser(row){
                this.$router.push({path:"/telInfo",query:{phone:row.phone}})
            },
            dial(row) {
                this.phone = row
                this.showadd = true
            },
            importFile() {
                this.showadd1 = true
            },
            downloadFile() {
                window.open('https://img.aktivakus.com/template.xlsx')
            },
            getconfirm() {
                if (this.form.channel == "WhatsApp") {
                    _api.get(apiurl.waDial, {
                        phone: this.phone,
                    }).then(res => {
                        window.open('https://wa.me/' + this.phone, '_blank')
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                } else {
                    _api.get(apiurl.dial, {
                        phone: this.phone,
                        type: 1,
                        nation: localStorage.getItem("nation"),
                    }).then(res => {
                        alert(res.message);
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                }
                this.showadd = false
            },
            handleSelectionChange(val) {
                var authority = [];
                this.multipleSelection = val;
                for(var i = 0; i< this.multipleSelection.length; i++){
                    authority.push(this.multipleSelection[i].id)
                }
                this.selectData=authority.join(",");
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            getclosefp() {
                this.$refs.form.resetFields();
                this.showaddfp = false
            },
            getclose1() {
                this.showadd1 = false
            },
            getconfirm1() {
                this.$refs.upload.submit();     // 手动触发上传
                this.showadd1 = false
            },
            getconfirmfp() {
                if (this.status != 3) {
                    if (this.status == 1) {
                        if (this.selectData == null) {
                            this.$message.error(this.$t('tel67'))
                            return
                        }
                    } else {
                        if (this.form1.value1 == null) {
                            this.$message.error(this.$t('tel87'))
                            return
                        }
                    }
                    
                    if (this.form1.principalId == null || this.form1.principalId == "") {
                        this.$message.error(this.$t('tel68'))
                        return
                    }
                }
                
                _api.post(apiurl.teldistributor, this.form1)
                .then(res => {
                    this.$notify.success({
                        title: this.$t('success'),
                        message: this.$t('czcg')
                    })
                    this.getList()
                    this.showaddfp = false
                    this.form1 = {
                        id: null,
                        selectData: null,
                        principalId:null,
                        type:null,
                        channel:null,
                    }
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
            },
            getList() {
                this.loading = true
                _api.get(apiurl.telList, {
                    page: this.pageNo,
                    size: this.pageSize,
                    blurry: this.searchform.blurry,
                    name: this.searchform.name,
                    idDial: this.searchform.idDial,
                    type:  this.searchform.type,
                    principalId: this.searchform.principalId,
                }).then(res => {
                    this.loading = false
                    this.blurry=null
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>